import { render, staticRenderFns } from "./performance.vue?vue&type=template&id=c5f424e8&scoped=true"
import script from "./performance.vue?vue&type=script&lang=js"
export * from "./performance.vue?vue&type=script&lang=js"
import style0 from "./performance.vue?vue&type=style&index=0&id=c5f424e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f424e8",
  null
  
)

export default component.exports